import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/classes',
      name: 'classes',
      component: () => import(/* webpackChunkName: "classes" */ './views/Classes.vue'),
    },
    {
      path: '/class/:uid',
      name: 'class',
      component: () => import(/* webpackChunkName: "class" */ './views/ClassDetail.vue'),
    }
  ],
});
